import { Transition } from "@headlessui/react";
import { InView, useInView } from "react-intersection-observer";
import { useState, useEffect } from "react";
import { content } from "./content.js";
import leadingLoopVideo from "./images/leadingLoopVideo.mp4";
import logoWide from "./images/logo.png";
import leading from "./images/leading.png";
import Intro from "./Intro.js";

const breakPoints = "md:w-[750px] w-[350px] sm:w-[580px] lg:w-[900px]";



const Header = () => (
  <div className={`flex flex-col py-10 justify-center ${breakPoints}`}>
    <img
      src={leading}
      alt="She is priceless"
      className="animate-fade w-[400px] h-auto object-cover pt-10"
    />
    <div className="text-3xl md:text-6xl flex flex-col pt-10 font-montserrat font-light">
      <span className="text-black text-left tracking-wider">
        Redefining leadership,
      </span>      
      <span className="text-mcGray text-right tracking-wider pt-2">
        empowering change.
      </span>
    </div>
    <div>


      
    </div>
  </div>
);

const BrandVoiceDisclaimer = () => (
  <div className={`flex flex-col justify-start ${breakPoints} w-full py-2`}>
    <div
      className={`flex flex-row justify-end gap-10 items-center ${breakPoints} w-full mb-5`}
    >
      <div className="flex flex-row ">
        <div className="text-black text-sm font-roboto font-semibold pt-3 tracking-wide">
          {" "}
          <span className="text-red uppercase font-semibold">BrandVoice</span> |
          Paid Program
        </div>
      </div>
    </div>
    <div>
      <hr className="w-full border-1 border-mcGray" />
    </div>
    <div className=" text-xs font-roboto  pt-3">
      Mar 6, 2025, 09:00am CAT
    </div>
  </div>
);

const FeaturedWoman = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedWoman, setSelectedWoman] = useState(null);
  const [scrollTop, setScrollTop] = useState(0);

  const handleClick = (item) => {
    setSelectedWoman(item);
    setShowModal(true);
    //set scroll back to top

  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <div>
      {content.map((item) => (
        <div
          className={`relative ${breakPoints} h-[750px] mb-[200px]`}
          key={item.firstName}
          onClick={() => handleClick(item)}
        >
          <Scroll item={item} />
        </div>
      ))}
      <Modal isOpen={showModal} onClose={handleClose} content={selectedWoman} />
    </div>
  );
};

const Modal = ({ isOpen, onClose, content }) => {
  
  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-mcBg2 flex flex-col z-50 justify-center items-center ${
        isOpen ? "block" : "hidden"
      }`}
    >
       <button className="text-black uppercase font-bold" onClick={onClose}>
        Close
      </button>
      {/* Modal content here */}
      {content && (
        <div className={`${breakPoints} overflow-y-scroll pt-14 md:pt-0 `}>
          <div className="text-black text-left pb-10">
            <div className="text-mcOrange text-4xl font-markForMC font-light">
              {content.firstName} {content.lastName}
            </div>
            <div className="font-markForMCm uppercase pt-2 font-bold">{content.title}</div>
          </div>

          {content.questionArray && content.questionArray.length > 0 && (
            <div className="text-black font-markWebPro pb-20 md:pb-0">
              {content.questionArray.map((question, index) => (
                <div key={index} className="modal-question">
                  <div className="text-mcGray text-xl font-bold">
                    {question}
                  </div>
                  <div
                    className="pb-4 font-poppins"
                    dangerouslySetInnerHTML={{
                      __html: content.responseArray[index],
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const Scroll = ({ item }) => {
  return (
    <InView triggerOnce={true} rootMargin="200px 0px">
      {({ inView, ref }) => (
        <div ref={ref} className="cursor-pointer">
          <Transition.Root show={inView}>
          <Transition.Child
              as="h3"
              enter="ease-in delay-[50ms] duration-[800ms] transition-all"
              enterFrom="opacity-0 translate-x-12"
              enterTo="opacity-100 translate-y-0"
              className="text-white text-[20px] md:text-[30px] bottom-[100px] md:bottom-0 uppercase tracking-wide font-bold font-markScForMCNarrowM z-40 absolute right-2 hover:text-black hover:underline"
            >
              Read More
            </Transition.Child>
            <Transition.Child
              as="h3"
              enter="ease-in delay-[50ms] duration-[800ms] transition-all"
              enterFrom="opacity-0 translate-x-12"
              enterTo="opacity-100 translate-y-0"
              className="text-mcOrange text-[50px] md:text-[100px] bottom-[200px] md:bottom-[240px] uppercase tracking-wide font-bold font-markScForMCNarrowM bg-mcBg2 z-40 absolute left-0"
            >
              {item.firstName}
            </Transition.Child>
            <Transition.Child
              as="h3"
              enter="ease-in delay-[50ms] duration-[800ms] transition-all"
              enterFrom="opacity-0 -translate-x-20"
              enterTo="opacity-100 translate-y-0"
              className=" text-[50px] md:text-[100px] bottom-[135px] md:bottom-[130px] uppercase font-bold tracking-wide font-markScForMCNarrowM pr-4 bg-mcBg2 absolute left-[100px] z-10"
            >
              {item.lastName}
            </Transition.Child>
            <img
              src={item.imageSrc}
              alt={item.firstName}
              className="w-[500px] absolute right-0 top-0"
            />
            <Transition.Child
              as="span"
              className="bg-mcBg2 text-[20px] uppercase tracking-wide md:bottom-0 bottom-[50px] left-0 absolute w-[350px] leading-tight font-markScForMCNarrowM"
              enter="ease-in delay-[800ms] duration-[600ms] transition-all"
              enterFrom="opacity-0 translate-y-12"
              enterTo="opacity-100 translate-y-0"
            >
              {item.title}
            </Transition.Child>
          </Transition.Root>
        </div>
      )}
    </InView>
  );
};

const SheisPriceless2 = () => {
  return (
    <div className={`bg-mcBg2 w-full h-full`}>
      <div className={`flex flex-col items-center justify-center`}>
        <div className={`flex flex-col items-center justify-center`}>
          <Header />
          <BrandVoiceDisclaimer />
          <Intro breakPoints={breakPoints} />          
          <FeaturedWoman />
        </div>
      </div>
    </div>
  );
};

  export default SheisPriceless2;
